class MembershipLimitError extends Error {
  constructor() {
    super("You are already a member of another account");
    this.status = 400;
  }
}

export default MembershipLimitError;
